<div class="flex flex-column gap-3 mt-1">

    <!-- Ce qui n'est pas parti, et pourquoi -->
    <app-message severity="warn" icon="fa-solid fa-triangle-exclamation" [title]="title"
        [messages]="['Le reste de la sélection a bien été supprimé. Les éléments ci-dessous sont toujours présents dans la liste.']">
    </app-message>

    <!-- Détail, ligne par ligne -->
    <p-table [value]="rows" size="small" class="flat" [scrollable]="true" scrollHeight="45vh">
        <ng-template #header>
            <tr>
                <th class="w-1 white-space-nowrap">Élément</th>
                <th>Motif</th>
            </tr>
        </ng-template>
        <ng-template #body let-row>
            <tr>
                <td class="white-space-nowrap font-semibold">{{ row.name }}</td>
                <td>{{ row.reason }}</td>
            </tr>
        </ng-template>
    </p-table>

    <!-- Fermeture -->
    <div class="flex justify-content-end">
        <p-button label="Fermer" [rounded]="true" [outlined]="true" (click)="onClickClose()"></p-button>
    </div>

</div>
